<template>
  <section class="sceneDetail">
    <header-com isTransparent></header-com>
    <div class="banner">
      <img :src="sceneDetail.banner" align="middle">
    </div>

    <div class="contentWrap">
      <!--<div class="hGroup">
        <img :src="sceneDetail.hGroup.topImg" align="middle">
        <h2 class="bold"  v-html="sceneDetail.hGroup.title"></h2>
        <p class="f28 grey6" v-html="sceneDetail.hGroup.content"></p>
      </div>-->

      <h3 class="f40 bold">相关单品 <span class="f28">({{proList.length}})</span></h3>
      <!--<h4 class="f28 grey9">献给所有永恒的少女</h4>-->

      <ul>
        <li v-for="(item,index) in proList" :key="index">
          <pro-info-card :item="item"/>
        </li>
      </ul>
    </div>


  </section>

</template>

<script>
  const sceneDetailObj = {
    1:{
      banner:'/images/home/zjb_banner2.png',
      hGroup:{
        topImg:'/images/home/banner_05.png',
        title:'四月是你的颜色，<br/>将春风带进办公室',
        content:'春风摇曳，大地换新，这一年最舒服的时刻里，万物都重新焕发勃勃生机。何谓一年之计在于春？是从这个春天开始，' +
                '释放内心感受，走出熟悉地带，换一只包包做战友，多一抹颜色给世界。<br/><br/>背上它们，你才是人间的四月天。 '
      },
      proListParams:{
        pageNum:1,
        pageSize:90,
        skus: '571553,571406,571282,570763,570758,570733,570600,570496,570470,570370,570311,570247,570224,570127,570104,570096,569970,569890,569861,569839,569812,569801,569764,569761,569733,569722,569713,569694,569693,569686,569476,569366,569336,569311,569279,569278,569275,569269,569239,569225,569187,569177,569119,569042,569036,568852,568848,568839,568713,568706,568698,568697,568615,568586,568520,568516,568489,568407,568392,568389,568365,568265,568231,568224,568172,568102,568070,568063,568035,568012,567995,567836,567811,567774,567762,567729,567705,567656,567606,567574,567558,567469,567468,567450,567360,567343,567212,567150,566982,566776,566618,566579,566468,566421,565975,565947,565761,565752,565626,565485,565484,565461,565211,564895,564832,564802,564766,564466,564420,564332,564262,564204,564192,563951,563751,563159,562960,562456,562089,561974,560265,559810,559192,558505,557927,557865,553542,552954,550986,542630,538875'
      }
    },
    2:{
      banner:'/images/home/zjb_banner3.jpg',
      hGroup:{
        topImg:'/images/home/banner_07.png',
        title:'背过10只经典大牌包，<br/>才知缘何经典',
        content:'没有人可以被一只包定义，但是在每只几十年前被设计出的包包身上，展现的，是穿越历史的审美，与跨越种族的精神内核，都值得被感受。 ' +
                '<br/><br/>只有见过大海的人，才有资格说偏爱小溪。 ' +
                '<br/><br/>只有背过这些包的你，才会更加独立的选择所爱。 '
      },
      proListParams:{
        pageNum:1,
        pageSize:84,
        skus: '571199,571091,571034,570995,570878,570803,570697,570683,570616,570602,570570,570403,569631,569156,569047,569041,569034,569027,569019,568995,568936,568667,568515,568503,568496,568456,568445,568358,568336,568332,568294,568292,568290,568235,568232,568098,568018,567964,567957,567899,567883,567846,567843,567765,567641,567397,567323,567211,567163,567154,567123,567100,566959,566561,566162,566078,565964,565917,565819,565708,565665,565637,565507,565501,565500,565497,565447,565429,565361,565341,565339,565316,565301,565277,565268,565229,565156,565087,565053,565052,565042,565022,565013,564998,564989,564986,564974,564971,564941,564928,564925,564882,564868,564815,564705,564695,564688,564678,564669,564595,564590,564582,564556,564554,564553,564534,564524,564458,564452,564433,564416,564396,564392,564391,564387,564369,564359,564344,564333,564273,564209,564187,564165,564162,564142,564130,564067,564054,563950,563904,563868,563851,563823,563814,563788,563712,563708,563701,563669,563185,563145,563133,563105,563103,563087,563066,563031,563000,562870,562837,562780,562761,562752,562750,562476,562460,562380,562355,562346,562290,562237,562228,562227,562207,562108,562101,561964,561955,561934,561927,561835,561774,561757,561742,561710,561683,561618,560770,560421,559441'
      }

    }
  };
  import homeApi from '@api/home'
  export default {
    name: "sceneDetail",
    components: {},
    data() {
      const id = this.$route.params.id;
      const sceneDetail = sceneDetailObj[id];
      return {
        sceneDetail,
        proList:[]
      }
    },
    watch: {},
    computed: {

    },
    created() {
    },
    mounted() {
      this.getProList()
    },
    methods: {
      //获取商品列表
      getProList(){
        homeApi.getProList(this.sceneDetail.proListParams).then(res=>{
          this.proList = res.result
        })
      },
    }

  }
</script>

<style lang="scss" scoped>
.sceneDetail{
  .banner{
    height: 420px;
    img{
      width: 100%;
      height: 100%;
    }
  }

  .contentWrap{
    padding: 74px 40px 40px;
    .hGroup{
      padding-bottom: 120px;
      img{
        width: 238px;
        margin-bottom: 10px;
      }
      h2{
        font-size: 62px;
        margin-bottom: 40px;
        line-height: 88px;
      }
      p{
        line-height: 44px;
      }
    }
    h3{
      margin-bottom: 20px;
    }
    ul{
      padding: 60px 0 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

}
</style>
